import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import check from "../../../assets/checked.png";

const ContactOptions = ({profile, chatBoxOpen}) => {
  const phone = profile.phone || profile.receiver_phone

  const handleCall = () => {
    if (phone) {
      window.location.href = `tel:${phone}`;
    }
  };

  const handleWhatsApp = () =>{
    console.log("phone", phone)
    if(phone){
      window.open(`https://wa.me/${phone}`, '_blank')
    }
  }

  return(
    <>
    {profile.connectionStatus === 'pending' ? (<div className="text-center">
      <div className="small text-muted mb-2">Requested</div>
      <img src={check} alt="Check" className="mb-2" style={{ width: "40px" }} />   
    </div>) : (<div className="text-center">
        <button className="btn btn-outline-info contact-btn mb-2 w-100" onClick={handleCall}>
          <i className="fa fa-phone me-1" aria-hidden="true" ></i> Call
        </button>
        <button className="btn btn-outline-success contact-btn mb-2 w-100" onClick={handleWhatsApp}>
          <i className="fa fa-whatsapp me-1" aria-hidden="true"  ></i> WhatsApp
        </button>
        <button className="btn btn-outline-primary contact-btn w-100" onClick={()=>chatBoxOpen(profile.user_id ? profile.user_id : typeof(profile.receiver_profile_id)==="string"?profile.sender_profile_id:profile.receiver_profile_id)}>
          <i className="fa fa-commenting-o me-1" aria-hidden="true"></i> Chat
        </button>
      </div>)}
    </>
  )
}

export default ContactOptions;